import { Component, Input } from '@angular/core';
import { PolicyVersions } from 'src/app/common/policy-versions';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent {
  @Input()
  maxHeight = 'inherit';

  lastUpdateDate = PolicyVersions.privacyPolicyLastUpdateDate;
}
